import { render, staticRenderFns } from "./AppElementListAddNew.vue?vue&type=template&id=6c822262"
import script from "./AppElementListAddNew.vue?vue&type=script&lang=js"
export * from "./AppElementListAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports